// table
import { StatisticUserComponent } from './user/statistic-user.component';


export const StatisticModule = angular.module('topbroker.statistic', [])
  .component('statisticUser', StatisticUserComponent)


  .name;
